export default __webpack_public_path__ + "static/media/landing2.ec7e62e8.png";